var _defs, _circle, _circle2, _path, _circle3, _path2, _path3, _path4, _circle4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_814",
    "data-name": "Group 814",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.301,
    height: 70.301,
    viewBox: "0 0 70.301 70.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 35.15,
    cy: 35.15,
    r: 35.15,
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 34.407,
    cy: 34.407,
    r: 34.407,
    transform: "translate(0.81 0.516)",
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M825.448,270.988a34.247,34.247,0,0,0,18.914-5.66c-1.271-6.931-6.094-7.328-6.094-7.328h-26.6s-4.55.373-5.975,6.749A34.249,34.249,0,0,0,825.448,270.988Z",
    transform: "translate(-790.2 -201.518)",
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 16.609,
    cy: 16.609,
    r: 16.609,
    transform: "translate(18.277 17.589)",
    fill: "#72351c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M642.68,158.36h10.643v8.514A5.32,5.32,0,0,1,648,172.2h0a5.32,5.32,0,0,1-5.32-5.32V158.36Z",
    transform: "translate(-613.156 -110.328)",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M643.673,157.06h8.611a1.016,1.016,0,0,1,1.016,1.016v7.5a5.32,5.32,0,0,1-5.32,5.32h0a5.32,5.32,0,0,1-5.32-5.32v-7.5a1.016,1.016,0,0,1,1.016-1.016Z",
    transform: "translate(-613.142 -109.422)",
    fill: "#fda57d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M852,240.457a15.317,15.317,0,0,0,10.643.03V239.18H852Z",
    transform: "translate(-822.464 -188.406)",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 15.253,
    cy: 15.253,
    r: 15.253,
    transform: "translate(19.633 22.257)",
    fill: "#fda57d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M833.82,140.869s6.427,13.042,24.568,5.46l-4.222-6.621-7.483-2.687Z",
    transform: "translate(-809.798 -117.232)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M833.82,140.239s6.427,13.042,24.568,5.46l-4.222-6.621-7.483-2.687Z",
    transform: "translate(-809.798 -116.793)",
    fill: "#72351c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M832.9,121.988a8.811,8.811,0,0,1,2.184-3.552c3-2.966,7.919-3.591,10.443-6.976a1.974,1.974,0,0,1-.91,2.784c2.427-.015,5.22-.227,6.585-2.217a4.522,4.522,0,0,1-.761,4.774c2.141.1,4.428,1.55,4.568,3.691a4.264,4.264,0,0,1-1.975,3.594,10.855,10.855,0,0,1-3.982,1.489C844.98,126.486,830.242,130.25,832.9,121.988Z",
    transform: "translate(-808.935 -99.425)",
    fill: "#72351c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M849.878,195.89h-.4l-7.868,7.009c-7.583-3.549-13.145,0-13.145,0l-8.25-6.715-.831.1a15.253,15.253,0,1,0,30.5-.391ZM834.6,205.581c-2.966,0-5.372-.607-5.372-1.344s2.405-1.344,5.372-1.344,5.372.607,5.372,1.344-2.405,1.344-5.375,1.344Z",
    transform: "translate(-799.738 -158.246)",
    fill: "#72351c"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(18.208 34.835)",
    fill: "#fda57d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(48.717 34.835)",
    fill: "#fda57d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.01d8879aa944e1ff18d99c92fbf60283.svg";
export { ForwardRef as ReactComponent };